import { CaretRight } from "@phosphor-icons/react";

import { Button } from "common/components/ui/Button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";
import { useSelectedWorkspaceContext } from "common/helpers/SelectedWorkspaceContext";
import useAppStore from "common/hooks/useAppStore";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

export default function CreateCampaign() {
  const isDesktop = useTwBreakpoint("lg");
  const { accounts_count: accountsCount, permissions } =
    useSelectedWorkspaceContext();

  const setIsCampaignModalOpen = useAppStore(
    (state) => state.setIsCampaignModalOpen,
  );

  const hasAccounts = accountsCount > 0;

  const buttonComponent = permissions.includes("campaigns_full") && (
    <Button
      onClick={() => setIsCampaignModalOpen(true)}
      size="sm"
      rightIcon={isDesktop && <CaretRight />}
      disabled={!hasAccounts}
      intent={isDesktop ? "default" : "iconOnly"}
    >
      {isDesktop ? "Create campaign" : <CaretRight />}
    </Button>
  );

  if (hasAccounts) {
    return buttonComponent;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>{buttonComponent}</TooltipTrigger>

      <TooltipContent>
        You must connect a LinkedIn account before creating your first campaign
      </TooltipContent>
    </Tooltip>
  );
}
